module.exports = __webpack_public_path__ + "static/Forager3-0c3dfcede6618b90ac081d3aeeaa444e.webp";